import styled from 'styled-components'
import { breakpoint } from '@sketch/global-styles'

export const Wrapper = styled.section`
  margin-bottom: 24px;

  padding: 24px;
  display: flex;
  flex-direction: column;

  font-size: ${({ theme }) => theme.fontSizes.E};
  line-height: 1.4;
  border-radius: ${({ theme }) => theme.radii.xxxlarge};

  /* This needs to be hard coded (dark) because the hero background is yellow
  and we don't want to change the text color between themes */
  color: hsl(0, 0%, 0%, 0.7);

  ${breakpoint('sm')`
    margin-bottom: 64px;
  `}

  a:not([class]) {
    text-decoration: underline;
    font-weight: ${({ theme }) => theme.fontWeights.semibold};

    /* This needs to be hard coded (dark) because the hero background is yellow
  and we don't want to change the text color between themes */
    color: hsl(0, 0%, 0%, 0.85);
  }
`

export const Title = styled.h1`
  margin: 0 0 4px 0;

  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: ${({ theme }) => theme.fontSizes.G};
  line-height: 1.6;

  /* This needs to be hard coded (dark) because the hero background is yellow
  and we don't want to change the text color between themes */
  color: hsl(0, 0%, 0%);
`

export const ActionWrapper = styled.div`
  margin-top: 16px;
`
